let configData = {
    loginUrl: null,
    ajaxHost: "/api/serv",
    apiStatus: 0,
    host: "",
    footText: "珠海兴诺能源技术有限公司 粤ICP备19041187号 © Copyright",
    formSize: "small",
    pickerOptions: {
        disabledDate(time) {
            return (time.getTime() > new Date(new Date().toLocaleDateString()).getTime());
        },
    },
    pickerOptionsMin: {
        disabledDate(time) {
            return (time.getTime() < new Date(new Date().toLocaleDateString()).getTime());
        },
    },
    draggable: false,
    mapKeyApi: "38963cf6e1d7092a3dfcf940b4979bd5",
    // echartsJS: "http://oper.oms-test.smartpevc.com/static/common/echarts.min.js",
    fileImg: "/api/file/",
    sysModulePkId: "1",
    footerUrl: "https://beian.miit.gov.cn",
    powerObj: {
        // 权限对应的code,在页面里面直接用 xx.query 来做按钮权限,权限直接加入到 $route.meat 里面的 privilegeVoList
        "100501": "query",
        "100503": "updata",
        "100504": "delete",
        "100508": "export",
        "100502": "add",
    },
    tableStripe: true,
    socketServer: "",
    tioConfig: {
        ws_protocol: "ws",
        ip: "10.0.110.86",
        // ip: "47.115.147.82",
        port: "9876",
        heartbeatTimeout: 5000,
        reconnInterval: 1000,
        binaryType: "arraybuffer",
    },
    languageShow: true,
    position: {
        lat: 22.546054,
        lng: 114.025974,
        city: "",
    },
    UEDITOR_HOME_URL: "/ueditor/",
};
//为了防止哪天在域名中间加了东西 或者接口域名变了 ，然后外面连接一个js 文件 js 文件里放这几个参数就可以了
// 其它打包路径已设置为相对路径 ,只和 static  和 index.html 文件 在同一层级就可以了
const win = window;
if (win.appConfig && typeof win.appConfig == "object") {
    configData = Object.assign(configData, win.appConfig);
}
export default configData;
